(function () {
  async function refreshDrawer() {
    try {
      const res = await fetch('/?section_id=mini-cart');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('form.mini-cart');
      const current = document.querySelector('mini-cart form.mini-cart');
      if (fresh && current) {
        current.replaceWith(fresh);
        return;
      }
    } catch (e) {}
    window.location.reload();
  }

  async function updateDiscount(code) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    return res.json();
  }

  async function applyCode(box) {
    const input = box.querySelector('.cart-discount__input');
    const button = box.querySelector('.cart-discount__btn');
    const msg = box.querySelector('.cart-discount__msg');
    const code = input.value.trim();
    if (!code) return;

    button.disabled = true;
    msg.hidden = true;

    try {
      const cart = await updateDiscount(code);
      const ok = (cart.discount_codes || []).some(function (d) {
        return d.code.toLowerCase() === code.toLowerCase() && d.applicable;
      });
      if (ok) {
        await refreshDrawer();
        return;
      }
    } catch (err) {}

    msg.textContent = msg.dataset.error;
    msg.hidden = false;
    button.disabled = false;
  }

  document.addEventListener('click', async function (e) {
    const apply = e.target.closest('.cart-discount__btn');
    if (apply) {
      e.preventDefault();
      applyCode(apply.closest('.cart-discount'));
      return;
    }
    if (e.target.closest('[data-cart-discount-remove]')) {
      e.preventDefault();
      await updateDiscount('');
      refreshDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('cart-discount__input')) {
      e.preventDefault();
      applyCode(e.target.closest('.cart-discount'));
    }
  });
})();